import { Flow_reportsPrune } from './Flow.Report'

export function Flow_initialise() {
    Flow_reportsPrune()
    window.setInterval(Flow_reportsPrune, 60 * 60 * 1000)
}
